import {
  Component,
  OnInit,
  OnDestroy,
  HostBinding,
  Inject
} from '@angular/core';
import { Store, select } from '@ngrx/store';
import { Observable, Subscription } from 'rxjs';
import { distinctUntilChanged } from 'rxjs/operators';
import {
  WebsocketGatewayService,
  ENVIRONMENT_CONFIG,
  EnvironmentConfig
} from '@ipreo/northstar';
import { MuniEnvironment, MuniEnvironmentParams } from '@ipreo/muni-shared';
import {
  SelectedUSTreasuryChangedAction,
  USTreasuryEventReceivedAction
} from '../../../state/us-treasuries/actions';
import {
  MarketDrawerRootReducerState,
  getLiveState,
  getUSTreasuriesDataState,
  getUSTreasuriesSelectedState
} from '../../../state/reducer';
import { USTreasury, USTreasuries } from '../../../models/us-treasury';
import { TreasuriesService } from '../../../services/treasuries.service';

@Component({
  selector: 'muni-gameday-market-drawer-ust',
  templateUrl: './ust.template.html',
  styleUrls: ['./ust.styles.scss']
})
export class USTComponent implements OnInit, OnDestroy {
  @HostBinding('class.marketDrawerSection')
  public section = true;

  public readonly treasuries: Observable<USTreasuries> = this.store.pipe(
    select(getUSTreasuriesDataState),
    distinctUntilChanged()
  );
  public readonly selected: Observable<USTreasury> = this.store.pipe(
    select(getUSTreasuriesSelectedState),
    distinctUntilChanged()
  );
  public readonly live: Observable<boolean> = this.store.pipe(
    select(getLiveState),
    distinctUntilChanged()
  );

  private liveSubscription: Subscription;
  private env: MuniEnvironment;

  constructor(
    private store: Store<MarketDrawerRootReducerState>,
    private wsgService: WebsocketGatewayService,
    private treasuriesService: TreasuriesService,
    @Inject(ENVIRONMENT_CONFIG) config: EnvironmentConfig
  ) {
    this.env = (config.params as MuniEnvironmentParams).env;
  }

  public ngOnInit(): void {
    this.connectToChannel();
  }

  public ngOnDestroy(): void {
    this.liveSubscription.unsubscribe();
  }

  public usTreasurySelected(usTreasury: USTreasury) {
    this.store.dispatch(new SelectedUSTreasuryChangedAction(usTreasury));
  }

  private connectToChannel(): void {
    this.liveSubscription = this.wsgService
      .subscribe(`munis-treasuries-${this.env}`)
      .subscribe((event: any) => {
        const treasury = this.treasuriesService.usTreasuryResponseToViewModel(
          event
        );
        this.store.dispatch(new USTreasuryEventReceivedAction(treasury));
      });
  }
}
